import styled from 'styled-components';

import {
  Loader as LoaderLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  max-width: 700px;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)`
`;

export const PaymentFeedback = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
`;

export const PaymentSegment = styled(SegmentLayoutComponent)`
  display: flex;
  flex-direction: column;

  &.ui.segment {
    margin-right: 20px;
    padding: 20px;
    width: 420px;
  }
`;

export const PaymentSummarySegment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    flex: 1;
    padding: 20px;
  }
`;

export const Header = styled(TextLayoutComponent.Header)`
  font-weight: 400;
`;

export const Loader = styled(LoaderLayoutComponent)`
`;

export const NumberPariticipantsContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const CostContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;

  :last-child {
    margin-bottom: 0px;
  }
`;

export const CostSummary = styled(TextLayoutComponent.Header)`
  font-size: 14px;
  font-weight: 400;
`;

export const Cost = styled(TextLayoutComponent)`
  font-size: 15px;
  font-weight: 500;
`;

export const Discount = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.discount};
  font-size: 15px;
  font-weight: 500;
`;

export const Text = styled(TextLayoutComponent)`
  margin-bottom: 10px;
`;

export const CardNameContainer = styled.div`
  margin-bottom: 20px;
`;
